module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"document-title":"免责条款与隐私协议"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
